import React, { useState } from 'react';
import { Pencil } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { fecha } from '../pages/agencia/ui';

/* Las fechas de un cobro, editables donde sea que se muestren.

   Estaba resuelto solo en la pantalla de Cobros, así que desde el detalle de
   Finanzas o desde la ficha del cliente la fecha era un texto muerto. Vive acá
   para que sea la misma en todos lados y no haya que acordarse de replicarla.

   Sirve para el vencimiento y para la emisión: `campo` elige cuál. La emisión
   importa más de lo que parece, porque define en qué mes cuenta el cobro en los
   reportes —el servidor recalcula el período al cambiarla—.

   Se puede cambiar en cualquier estado, incluso en un cobro ya pagado: a veces
   la fecha que quedó registrada es la que está mal. */

const TEXTOS = {
  vencimiento: { titulo: 'Cambiar el vencimiento', etiqueta: 'Vence el', aviso: 'Vencimiento actualizado' },
  emitido: {
    titulo: 'Cambiar la fecha de emisión', etiqueta: 'Se emitió el',
    aviso: 'Fecha de emisión actualizada',
    nota: 'Es la fecha con la que el cobro cuenta en los reportes de facturación.',
  },
};

export default function Vencimiento({ cobro, onCambio, children, campo = 'vencimiento' }) {
  const t = TEXTOS[campo] || TEXTOS.vencimiento;
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState('');
  const [guardando, setGuardando] = useState(false);

  // el rojo de "vencido" solo aplica al vencimiento, no a la emisión
  const vencido = campo === 'vencimiento'
    && ['pendiente', 'vencido'].includes(cobro.estado)
    && cobro.habilitado !== 0
    && cobro.vencimiento
    && String(cobro.vencimiento).slice(0, 10) < new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);

  const abrir = () => { setValor(String(cobro[campo] || '').slice(0, 10)); setEditando(true); };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await api.put('/agency/cobros/' + cobro.id, { [campo]: valor || null });
      toast.success(t.aviso);
      setEditando(false);
      if (onCambio) onCambio(valor);
    } catch { toast.error('No se pudo guardar'); }
    finally { setGuardando(false); }
  };

  return (
    <>
      <button className="celda-editable" title={t.titulo} onClick={abrir}
        style={{ color: vencido ? '#ef4444' : 'inherit' }}>
        {children || fecha(cobro[campo])}<Pencil size={11} />
      </button>

      {editando && (
        <div className="modal-overlay" onClick={() => setEditando(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <h2>{t.titulo}</h2>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', margin: '4px 0 16px' }}>
              {cobro.cliente ? cobro.cliente + ' · ' : ''}{cobro.concepto || cobro.servicio || 'Cobro'}
            </p>
            <form onSubmit={guardar}>
              <div className="form-group"><label>{t.etiqueta}</label>
                <input type="date" value={valor} autoFocus onChange={e => setValor(e.target.value)} />
                {t.nota && <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 5 }}>{t.nota}</div>}
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setEditando(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={guardando}>Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
